/*! contactForm.js | v5.1.0 | license Copyright (C) 2020 - 2026 Taichi Matsutaka */
/*
 *
 * @name    : contactForm.js
 * @content : contactForm
 * @creation: 2020.05.07
 * @update  : 2026.04.23
 * @version : 5.1.0
 *
 */
class contactForm {
	constructor(target, options){
		/**************************************************************
		 * defaults options
		**************************************************************/
		if (typeof target === 'string') {
			this.target = document.querySelector(target);
		} else {
			this.target = target;
		}

		if( !this.target ){
			return false;
		}

		const defaults = {
			scrollElement: 'body',
			controlClass: 'p-form__control',
			button      : '.p-form__button',
			submit      : '.p-form__submit',
			check       : '.p-form__check',

			required: [
				'[name="f_type"],[name="f_name"],[name="f_kana"],[name="f_mail"],[name="f_tel"]',
			],
			linkageRequired      : null,
			requiredStatus       : false,
			requiredStatusCurrent: '.js-count__current',
			requiredStatusTotal  : '.js-count__total',
			requiredStatusMode   : 'remaining', // 'remaining'（残数が減る） or 'completed'（完了数が増える）
			doneTarget           : null,

			stepFunctions      : null,
			agree              : '[name="f_policy"]',
			emailCheck         : true,
			emailCheckRegex    : /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
			emailConfirm       : true,
			emailConfirmArray  : ['[name="f_mail"]','[name="f_mail-check"]'],
			telCheck           : true,
			telCheckRegex      : /^[0-9]+$/,
			yubinBango         : true,
			textareaPlaceholder: false,
			textareaSelector   : '.js-textarea',
			textareaDummyClass : 'p-form__txtbox--dummy',
			textareaKeepHeight : false,

			file             : true,
			fileSelector     : '.p-form__file',
			fileTxtSelector  : '.p-form__file__txt',
			fileClearSelector: '.p-form__file__clear',

			animation          : true,
			animationSpeed     : 500,
			animationDifference: [0],
			animationPosition  : 0,
			animationHierarchy : 1,
			animationEasing    : function (t, b, c, d) { return c * t / d + b; },

			errorTextClass       : [],
			errorTextEmailCheck  : '正しい形式で入力してください。',
			errorTextEmailConfirm: '確認用のメールアドレスが一致していません。',
			errorTextTelCheck    : '正しい形式で入力してください。',
			errorTextRequired    : '必須項目を入力してください。',

			errorClass   : 'is-error',
			disabledClass: 'is-disabled',
			doneClass    : 'is-done',
		};

		/**************************************************************
		 * options
		************************************************************ */
		this.options = { ...defaults, ...options };

		/**************************************************************
		 * property
		************************************************************ */
		this.button      = this.target.querySelector( this.options['button'] );
		this.check       = this.target.querySelector( this.options['check'] );
		this.submit      = this.target.querySelector( this.options['submit'] );
		this.agree       = this.target.querySelectorAll( this.options['agree'] );
		this.agreeLength = this.agree.length;

		this.nowStep    = 1;
		this.stepLength = 1;

		if( this.options['stepFunctions'] != null ) {
			this.stepLength = this.options['stepFunctions'].length;
		}

		this.requiredElements = '';
		this.emailElements    = '';
		this.telElements      = '';

		if( this.stepLength > 1 ){
			this.target.dataset.state = this.nowStep;
			this.requiredElements = this.target.querySelectorAll( this.options['required'][ this.nowStep - 1 ] );
			this.emailElements    = this.target.querySelectorAll('[data-step="' + this.nowStep + '"] [type="email"]');
			this.telElements      = this.target.querySelectorAll('[data-step="' + this.nowStep + '"] [type="tel"]');

			/* stepFunctions */
			this.options['stepFunctions'][ this.nowStep - 1 ]();

		} else{
			this.requiredElements = this.target.querySelectorAll( this.options['required'][0] );
			this.emailElements    = this.target.querySelectorAll('[type="email"]');
			this.telElements      = this.target.querySelectorAll('[type="tel"]');
		}

		/*
		 * errorFlgs
		 *
		 * チェック項目毎に個別で管理
		 *
		 * trueがエラーあり、falseがエラーなし
		 * 通常は送信できる状態で、エラーがあればtrueに変更し送信させない。
		 *
		 */
		this.hasErrorRequired     = false;
		this.hasErrorEmailCheck   = false;
		this.hasErrorEmailConfirm = false;
		this.hasErrorTelCheck     = false;



		/**************************************************************
		 * method
		**************************************************************/
		this._checkDone();
		this._linkageRequired();
		this._setupAgreeClick();
		this._requiredCheckChange( this.requiredElements );
		this._yubinBangoInit();
		this._telCheckChange( this.telElements );
		this._emailCheckChange( this.emailElements );
		this._emailConfirmChange();
		this._textareaPlaceholderInit();
		this._fileChange();
		this._checkButtonClickInit();
		this._submitButtonClickInit();
		this._requiredStatusSetup();
	}

	/**************************************************************
	 * searchControl
	 * controlClass を持つ親要素を取得
	**************************************************************/
	_searchControl = (targetElement) => {
		const selector = '.' + this.options['controlClass'];
		const control  = targetElement.closest(selector);
		return control || targetElement;
	};


	/**************************************************************
	 * erroeMessage
	 * エラーメッセージの出力・削除
	**************************************************************/
	/* ---------- エラーメッセージを表示 ---------- */
	_errorMessageAdd = (targetElement, text) => {
		/* ---------- 要素とメッセージの準備・総運輸う ---------- */
		const p = document.createElement('p');

		const nameJa = targetElement.dataset.nameJa;
		if( nameJa ) text = text.replace( '[name-ja]', nameJa );

		p.innerHTML = text;
		p.classList.add( 'js-error-text' );

		const control = this._searchControl( targetElement );

		control.parentNode.appendChild( p );

		/* ---------- その他クラスの付与 ---------- */
		for ( let i = 0; i < this.options['errorTextClass'].length; i++ ) {
			p.classList.add( this.options['errorTextClass'][i] );
		}

		control.classList.remove( this.options['doneClass'] );
		control.classList.add( this.options['errorClass'] );
	};

	/* ---------- エラーメッセージの削除 ---------- */
	_errorMessageRemove = (targetList) => {
		for ( let i = 0; i < targetList.length; i++ ) {
			/* ---------- 要素とクラスの削除 ---------- */
			const control = targetList[i].previousElementSibling;
			targetList[i].parentNode.removeChild( targetList[i] );

			control.classList.remove( this.options['errorClass'] );
		}
	};


	/**************************************************************
	 * checkDone
	 * 入力済みかのチェック
	 * 対象はcontrolClassの中の「input,select,textarea」
	**************************************************************/
	_checkDone = () => {
		const input = this.target.querySelectorAll('.' + this.options['controlClass'] + ' input,' + '.' + this.options['controlClass'] + ' select,' + '.' + this.options['controlClass'] + ' textarea');

		/* ---------- setDoneState ---------- */
		const setDoneState = (inputElement) => {
			const control = this._searchControl( inputElement );

			let value = '';

			if( inputElement.type === 'radio' || inputElement.type === 'checkbox' ){
				/* radio、checkboxの時は nameから複数を取得 */
				const inputs = this.target.querySelectorAll( '[name="'+ inputElement.name +'"]' );

				for ( let i = 0; i < inputs.length; i++) {
					if( inputs[i].checked == true ){
						value = inputs[i].value;
						break;
					}
				}
			} else{
				/* 通常は valueを取得 */
				value = inputElement.value;
			}

			/* ----- 判定 ----- */
			if( value !== '' ){
				control.classList.add( this.options['doneClass'] );
			} else{
				control.classList.remove( this.options['doneClass'] );
			}
		};

		/* ---------- check ---------- */
		for ( let i = 0; i < input.length; i++ ) {
			input[i].addEventListener('change', () => {
				setDoneState( input[i] );
			});
		}
	};


	/**************************************************************
	 * linkageRequired
	 * チェックボックスに連動して必須項目を変更
	**************************************************************/
	_linkageRequired = () => {
		if( this.options['linkageRequired'] == null ) return false;

		/* ---------- オブジェクトを配列に変換 ---------- */
		const switchArray   = Object.keys( this.options['linkageRequired'] );
		const requiredArray = Object.values( this.options['linkageRequired'] );

		/* ---------- 要素を配列に格納 ---------- */
		let switchInput   = [];
		for ( let i = 0; i < switchArray.length; i++ ) {
			if( this.target.querySelector( switchArray[i] ) ){
				switchInput.push( this.target.querySelector( switchArray[i] ) );
			}
		}

		/* ---------- 判定 ---------- */
		for ( let i = 0; i < switchInput.length; i++ ) {
			switchInput[i].addEventListener('change', () => {
				let linkage_required = '';

				/* ----- 全てのinputをチェック ----- */
				for ( let k = 0; k < switchInput.length; k++ ) {
					if( switchInput[k].checked == true ){
						/* ----- checkedだったら、必須項目に追加 ----- */
						linkage_required += ',';
						linkage_required += requiredArray[k];
					} else{
						/* ----- checkedではなかったら、エラーメッセージを削除 ----- */
						const notRequiredInput = this.target.querySelectorAll( requiredArray[k] );

						for ( let m = 0; m < notRequiredInput.length; m++ ) {
							const control = this._searchControl( notRequiredInput[m] );
							const erroeText = control.parentNode.querySelectorAll('.js-error-text');
							this._errorMessageRemove( erroeText );
						}
					}
				}

				/* ----- 変化した必須項目をセット -----  */
				this.requiredElements = this.target.querySelectorAll( this.options['required'] + linkage_required );
				this._requiredCheckChange( this.requiredElements );
			});
		}
	};


	/**************************************************************
	 * agreeClick
	 * プライバシーポリシーのチェックでbuttonのクラスを制御
	**************************************************************/
	/* ---------- click ---------- */
	_setupAgreeClick = () => {
		if( this.button && this.agree ){
			this.button.classList.add( this.options['disabledClass'] );

			for ( let i = 0; i < this.agree.length; i++ ) {
				this.agree[i].addEventListener('change', () => {
					this._agreeCheck();
				});
			}

			window.addEventListener('pageshow', () => {
				this._agreeCheck();
			});
		}
	};

	/* ---------- check ---------- */
	_agreeCheck = () => {
		let agreeCount = 0;

		for ( let i = 0; i < this.agree.length; i++ ) {
			if( this.agree[i].checked == true ){
				agreeCount++;
			}
		}

		if( agreeCount == this.agreeLength ){
			this.button.classList.remove( this.options['disabledClass'] );
		} else{
			this.button.classList.add( this.options['disabledClass'] );
		}
	};


	/**************************************************************
	 * requiredCheck
	 * 必須項目の判定
	**************************************************************/
	/* ---------- 判定 ---------- */
	_requiredCheckCheck = (inputElement) => {
		let value = '';

		if( inputElement.type === 'radio' || inputElement.type === 'checkbox' ){
			/* radio、checkboxの時は nameから複数を取得 */
			const inputs = this.target.querySelectorAll( '[name="'+ inputElement.name +'"]' );

			for ( let j = 0; j < inputs.length; j++ ) {
				if( inputs[j].checked == true ){
					value = inputs[j].value;
					break;
				}
			}
		} else{
			/* 通常はは valueを取得 */
			value = inputElement.value;
		}

		/* ----- 判定 ----- */
		if( value === '' ){
			this._errorMessageAdd( inputElement , this.options['errorTextRequired'] );
			this.hasErrorRequired = true;
		}
	};

	/* ---------- change event ---------- */
	_requiredCheckChange = (targetList) => {
		for ( let i = 0; i < targetList.length; i++) {
			targetList[i].addEventListener('change', () => {
				/* メッセージを削除 */
				const control = this._searchControl( targetList[i] );
				const erroeText = control.parentNode.querySelectorAll('.js-error-text');
				this._errorMessageRemove( erroeText );

				/* errorFlg初期化 */
				this.hasErrorRequired = false;

				/* 判定 */
				this._requiredCheckCheck( targetList[i] );
			});
		}
	};

	/* ---------- submit ---------- */
	_requiredCheckSubmit = () => {
		let name = '';

		for ( let i = 0; i < this.requiredElements.length; i++ ) {
			/* ----- ひとつ前のnameと現在のnameが一緒だったらスキップ ----- */
			if( name === this.requiredElements[i].name ){
				continue;
			}

			/* 判定 */
			this._requiredCheckCheck( this.requiredElements[i] );

			/* ----- nameを再セット ----- */
			name = this.requiredElements[i].name;
		}
	};


	/**************************************************************
	 * yubinBango
	 * YubinBango.jsと連動
	 * YubinBango.jsで郵便番号から都道府県、市区町村などが自動で入力されますが、
	 * changeイベントが発動しません。
	 * それを補うために、郵便番号を入力したら、自動入力される要素も合わせて必須項目のチェックを行います。
	**************************************************************/
	_yubinBangoInit = () => {
		if( this.options['yubinBango'] === true ){
			const postalCode = this.target.querySelector('.p-postal-code');
			const autoInput  = this.target.querySelectorAll('.p-region,.p-locality,.p-street-address');

			if (postalCode) {
				postalCode.addEventListener('change', () => {
					for ( let i = 0; i < autoInput.length; i++ ) {
						/* メッセージを削除 */
						const control = this._searchControl( autoInput[i] );
						const erroeText = control.parentNode.querySelectorAll('.js-error-text');
						this._errorMessageRemove( erroeText );

						/* errorFlg初期化 */
						this.hasErrorRequired = false;

						/* 判定 */
						setTimeout(() => {
							this._requiredCheckCheck( autoInput[i] );
						},300);
					}
				});
			}
		}
	};


	/**************************************************************
	 * telCheck
	 * 電話番号が数字かどうか判定（ハイフンありでも機能）
	**************************************************************/
	/* ---------- 判定 ---------- */
	_telCheckCheck = (inputElement) => {
		let value = inputElement.value;

		if( this.options['telCheckRegex'] == '/^[0-9]+$/' ){
			// 数字のチェックだったら、ハイフンを削除して判定
			value = value.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi,'');
		}

		if( value !== '' && !value.match( this.options['telCheckRegex'] ) ) {
			this._errorMessageAdd( inputElement , this.options['errorTextTelCheck'] );
			this.hasErrorTelCheck = true;
		}
	};

	/* ---------- change event ---------- */
	_telCheckChange = (targetList) => {
		if( this.options['telCheck'] === true ){
			for ( let i = 0; i < targetList.length; i++ ) {
				targetList[i].addEventListener('change', () => {
					const value = targetList[i].value;

					/* 全角を半角にする */
					const halfValue = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
						return String.fromCharCode(s.charCodeAt(0) - 65248);
					});
					targetList[i].value = halfValue;

					/* メッセージを削除 */
					const control = this._searchControl( targetList[i] );
					const erroeText = control.parentNode.querySelectorAll('.js-error-text');
					this._errorMessageRemove( erroeText );

					/* errorFlg初期化 */
					this.hasErrorTelCheck = false;

					/* 判定 */
					this._telCheckCheck( targetList[i] );
				});
			}
		}
	};

	/* ---------- submit ---------- */
	_telCheckSubmit = (targetList) => {
		if( this.options['telCheck'] === true ){
			for ( let i = 0; i < targetList.length; i++ ) {
				/* 判定 */
				this._telCheckCheck( targetList[i] );
			}
		}
	};


	/**************************************************************
	 * emailCheck
	 * メールが正しい形式か判定
	**************************************************************/
	/* ---------- 判定 ---------- */
	_emailCheckCheck = (inputElement) => {
		const value = inputElement.value;
		if( value !== '' && !value.match( this.options['emailCheckRegex'] ) ){
			this._errorMessageAdd( inputElement , this.options['errorTextEmailCheck'] );
			this.hasErrorEmailCheck = true;
		}
	};

	/* ---------- change event ---------- */
	_emailCheckChange = (targetList) => {
		if( this.options['emailCheck'] === true ){
			for ( let i = 0; i < targetList.length; i++ ) {
				targetList[i].addEventListener('change', () => {
					/* メッセージを削除 */
					const control = this._searchControl( targetList[i] );
					const erroeText = control.parentNode.querySelectorAll('.js-error-text');
					this._errorMessageRemove( erroeText );

					/* errorFlg初期化 */
					this.hasErrorEmailCheck = false;

					/* 判定 */
					this._emailCheckCheck( targetList[i] );
				});
			}
		}
	};

	/* ---------- submit ---------- */
	_emailCheckSubmit = (targetList) => {
		if( this.options['emailCheck'] === true ){
			for ( let i = 0; i < targetList.length; i++ ) {
				/* 判定 */
				this._emailCheckCheck( targetList[i] );
			}
		}
	};


	/**************************************************************
	 * emailConfirm
	 * メールと確認が合っているかの判定
	**************************************************************/
	/* ---------- 判定 ---------- */
	_emailConfirmCheck = () => {
		const emailElement      = this.target.querySelector( this.options['emailConfirmArray'][0] );
		const emailAgainElement = this.target.querySelector( this.options['emailConfirmArray'][1] );

		if( emailElement && emailAgainElement ){
			if( emailElement.value !== emailAgainElement.value ){
				this._errorMessageAdd( emailAgainElement , this.options['errorTextEmailConfirm'] );
				this.hasErrorEmailConfirm = true;
			}
		}
	};

	/* ---------- change event ---------- */
	_emailConfirmChange = () => {
		if( this.options['emailConfirm'] === true ){
			const emailAgainElement = this.target.querySelector( this.options['emailConfirmArray'][1] );

			if( emailAgainElement ){
				emailAgainElement.addEventListener('change', () => {
					/* メッセージを削除 */
					const control = this._searchControl( emailAgainElement );
					const erroeText = control.parentNode.querySelectorAll('.js-error-text');
					this._errorMessageRemove( erroeText );

					/* errorFlg初期化 */
					this.hasErrorEmailConfirm = false;

					/* 判定 */
					this._emailConfirmCheck();
				});
			}
		}
	};

	/* ---------- submit ---------- */
	_emailConfirmSubmit = () => {
		if( this.options['emailConfirm'] === true ){
			const emailAgainElement = this.target.querySelector( this.options['emailConfirmArray'][1] );
			this._emailConfirmCheck( emailAgainElement );
		}
	};


	/**************************************************************
	 * textareaPlaceholder
	 * テキストエリアのプレスホルダーは、一部のブラウでで改行できないので、その対策
	**************************************************************/
	_textareaPlaceholderInit = () => {
		if( this.options['textareaPlaceholder'] === true ){
			const textarea = this.target.querySelector( this.options['textareaSelector'] );

			if( !textarea ) return false;

			const textareaClass = textarea.getAttribute('class');
			const placeholder   = textarea.getAttribute('placeholder');

			/* ---------- プレスホルダーのシングルクォーテーションをダブルクォーテーションに置き換え ---------- */
			const placeholderReplaced = placeholder.replace(/'/g, '"');

			/* ---------- ダミーの要素を作って、そこの高さを取得する ----------  */
			const dummyTextarea = document.createElement('p');
			dummyTextarea.setAttribute('class', textareaClass );
			dummyTextarea.classList.add( this.options['textareaDummyClass'] );
			dummyTextarea.innerHTML = placeholderReplaced;
			textarea.parentNode.appendChild( dummyTextarea );
			textarea.setAttribute('placeholder',' ');

			/* ----- 配置 ----- */
			textarea.parentNode.style.position = 'relative';

			if( this.options['textareaKeepHeight'] === true ){
				const textareaKeepHeight = () => {
					const height = dummyTextarea.clientHeight;
					textarea.style.height = height + 10 + 'px';
				};

				window.addEventListener('load', textareaKeepHeight );
				window.addEventListener('resize', textareaKeepHeight );
			}


			const checkValue = () => {
				const letterLength = textarea.value.length;

				if( letterLength === 0 ){
					dummyTextarea.classList.remove('is-hidden');
				} else{
					dummyTextarea.classList.add('is-hidden');
				}
			};

			window.addEventListener('load', checkValue );
			textarea.addEventListener('keyup', checkValue );
			textarea.addEventListener('keydown', checkValue );
			textarea.addEventListener('change', checkValue );
		}
	};


	/**************************************************************
	 * fileChange
	 * ファイルを追加・削除した時の動き
	**************************************************************/
	_fileChange = () => {
		if( this.options['file'] === true ){
			const file = this.target.querySelectorAll( this.options['fileSelector'] );

			for ( let i = 0; i < file.length; i++ ) {
				const input       = file[i].querySelector('input[type="file"]');
				const txtElement  = file[i].querySelector( this.options['fileTxtSelector'] );
				const clearButton = file[i].querySelector( this.options['fileClearSelector'] );
				const defaultTxt  = txtElement.innerHTML;

				/* ---------- file change ----------  */
				input.addEventListener('change',() => {
					const fileName = input.files[0].name;

					if( fileName ){
						txtElement.textContent = fileName;
						file[i].classList.add( this.options['doneClass'] );
					} else{
						txtElement.textContent = defaultTxt;
						file[i].classList.remove( this.options['doneClass'] );
					}
				});

				/* ---------- clear click ----------  */
				clearButton.addEventListener('click',( event ) => {
					event.preventDefault();

					input.value          = '';
					txtElement.textContent = defaultTxt;
					file[i].classList.remove( this.options['doneClass'] );

					this._requiredStatusRecountAll();
				})
			}
		}
	}


	/**************************************************************
	 * scrollAnimation
	 * スクロールアニメーション
	**************************************************************/
	_scrollAnimation = (toElement) => {
		if( this.options['animation'] == true ){
			let difference = 0;

			/* ---------- difference ---------- */
			if( this.options['animationDifference'] !== null ){
				let regexp = new RegExp('^(\\+|\\-)?(0[1-9]{0,2}|\\d{0,3})(,\\d{3})*(\\.[0-9]+)?$', 'g');

				for ( let i = 0; i < this.options['animationDifference'].length; i++ ) {
					if( regexp.test( this.options['animationDifference'][i] ) == true ){
						difference += this.options['animationDifference'][i];
					} else{
						let difference_element = document.querySelector( this.options['animationDifference'][i] );
						difference += difference_element.clientHeight;
					}
				}
			}

			/* ---------- window ---------- */
			let _window   = '';
			let _windowFrom   = '';

			if( this.options['scrollElement'] === 'body' ){
				_window     = window;
				_windowFrom = (function() {
					if('scrollingElement' in document) return document.scrollingElement;
					if(navigator.userAgent.indexOf('WebKit') != -1) return document.body;
					return document.documentElement;
				})();
			} else{
				_window     = document.querySelector(this.options['scrollElement']);
				_windowFrom = _window;
			}

			/* ---------- animation ---------- */
			let start_time  = Date.now();
			let scroll_from = _windowFrom.scrollTop;
			let position    = toElement.getBoundingClientRect().top - difference;

			const loop = () => {
				const currentTime = Date.now() - start_time;
				if (currentTime < this.options['animationSpeed']) {
					_window.scrollTo(0, this.options['animationEasing'](
						currentTime, scroll_from, position, this.options['animationSpeed']
					));
					window.requestAnimationFrame(loop);
				} else {
					_window.scrollTo(0, position + scroll_from);
				}
			};
			loop();

		} else if( this.options['animation'] == false ){
			_window.scrollTo( 0 , this.options['animationPosition'] );
		}
	};


	/**************************************************************
	 * _submitWithRecaptcha
	 * _getRecaptchaSiteKey
	 * submit
	**************************************************************/
	_getRecaptchaSiteKey = () => {
		const script = document.querySelector('script[src*="recaptcha/api.js?render="], script[src*="recaptcha/api.js&render="]');

		if( !script ){
			return '';
		}

		const src = script.getAttribute('src');
		const url = new URL(src, window.location.href);
		return url.searchParams.get('render') || '';
	};

	_submitWithRecaptcha = () => {
		const doSubmit = () => {
			this.target.classList.add('is-submit');
			this.target.submit();
		};

		const recaptchaInput = this.target.querySelector('[name="recaptcha_token"]');

		// hiddenが無ければ通常送信
		if( !recaptchaInput ){
			doSubmit();
			return;
		}

		if( typeof grecaptcha === 'undefined' ){
			alert('reCAPTCHAの読み込みに失敗しました。');
			return;
		}

		const siteKey = this._getRecaptchaSiteKey();

		if( !siteKey ){
			alert('reCAPTCHAのsite keyを取得できませんでした。');
			return;
		}

		grecaptcha.ready(() => {
			grecaptcha.execute(siteKey, { action: 'contact' }).then((token) => {
				recaptchaInput.value = token;
				doSubmit();
			}).catch(() => {
				alert('reCAPTCHAの取得に失敗しました。');
			});
		});
	};



	/**************************************************************
	 * check click
	 * 確認ボタンを押した時
	**************************************************************/
	_checkButtonClickInit = () => {
		if( this.check ){
			this.check.addEventListener('click', (e) => {
				e.preventDefault();

				/* ----- エラーメッセージ削除 -----  */
				const erroeText = this.target.querySelectorAll('.js-error-text');
				this._errorMessageRemove( erroeText );

				/* ----- エラーチェック -----  */
				this._requiredCheckSubmit();
				this._telCheckSubmit( this.telElements );
				this._emailCheckSubmit( this.emailElements );
				this._emailConfirmSubmit();

				/* ----- エラーがなければ、フォームを作動 ----- */
				if(
					this.hasErrorRequired     === false &&
					this.hasErrorEmailCheck   === false &&
					this.hasErrorEmailConfirm === false &&
					this.hasErrorTelCheck     === false
				){
					if( this.nowStep === this.stepLength ){
						this._submitWithRecaptcha();
						return false;
					} else{
						this.nowStep++;
						this.target.dataset.state = this.nowStep;

						if( typeof this.options['stepFunctions'][ this.nowStep - 1 ] === 'function' ){
							this.options['stepFunctions'][ this.nowStep - 1 ]();
						}

						this.requiredElements = this.target.querySelectorAll( this.options['required'][ this.nowStep - 1 ] );
						this.emailElements    = this.target.querySelectorAll('[data-step="' + this.nowStep + '"] [type="email"]');
						this.telElements      = this.target.querySelectorAll('[data-step="' + this.nowStep + '"] [type="tel"]');

						this._requiredCheckChange( this.requiredElements );
						this._telCheckChange( this.telElements );
						this._emailCheckChange( this.emailElements );
					}
				} else{
					const firstError = this.target.querySelector('.js-error-text');
					const control    = firstError ? firstError.previousElementSibling : null;

					if( control ){
						this._scrollAnimation( control );
					} else{
						this._scrollAnimation( this.target );
					}
				}

				/* ----- 次のためにフラグを初期化 ----- */
				this.hasErrorRequired     = false;
				this.hasErrorEmailCheck   = false;
				this.hasErrorEmailConfirm = false;
				this.hasErrorTelCheck     = false;

			});
		}
	};


	/**************************************************************
	 * submit click
	 * 送信ボタンを押した時
	**************************************************************/
	_submitButtonClickInit = () => {
		if( this.submit ){
			this.submit.addEventListener('click', (e) => {
				e.preventDefault();
				this._submitWithRecaptcha();
			});
		}
	};


	/**************************************************************
	 * requiredStatus
	 * 全てのエラーチェックが終わって判定するため一番最後
	 *
	 * status配列を、必須項目の分用意する。
	 * 入力済みが1、未入力が0とし、0の個数をカウントし判定する。
	**************************************************************/
	/* ---------- init ---------- */
	_requiredStatusInit = () => {
		/* ---------- settings ---------- */
		this.requiredStatusRequired  = [];
		this.requiredStatusStatus    = [];
		this.requiredStatusRemaining = 0;

		this._requiredStatusSettings();

		/* ---------- load count ---------- */
		this._requiredStatusRecountAll();

		// 自動入力や住所自動入力対応のため、change時に全ての必須項目を判定する
		for ( let i = 0; i < this.requiredElements.length; i++ ) {
			this.requiredElements[i].addEventListener('change', () => {
				this._requiredStatusRecountAll();
			});
		}
	};
	_requiredStatusSetup = () => {
		this.requiredStatusCurrentTarget = this.target.querySelector( this.options['requiredStatusCurrent'] );
		this.requiredStatusTotalTarget   = this.target.querySelector( this.options['requiredStatusTotal'] );
		this.requiredStatusDoneTarget    = this.target.querySelectorAll( this.options['doneTarget'] );

		if( this.options['requiredStatus'] === true && this.target.querySelector( this.options['requiredStatusCurrent'] ) ){
			window.addEventListener('pageshow', () => {
				this._requiredStatusInit();
			});
		}
	};

	/* ---------- recount ---------- */
	_requiredStatusRecountAll = () => {
		for ( let i = 0; i < this.requiredStatusRequired.length; i++) {
			this._requiredStatusCount( this.requiredStatusRequired[i][0] );
		}
	};

	/* ---------- settings ---------- */
	_requiredStatusSettings = () => {
		// ++した後データ属性をセットするので、-1からスタート
		let length     = -1;
		let nameAarray = [];

		for ( let i = 0; i < this.requiredElements.length; i++ ) {
			/* ---------- total ---------- */
			/*
				checkbox,radioなどnameが同じものは、まとめて一つとカウントする。
				合わせてstatus配列を生成
			*/
			const name = this.requiredElements[i].getAttribute('name');

			if( nameAarray.indexOf( name ) == -1 ){
				nameAarray.push( name );
				this.requiredStatusStatus.push( 0 );
				this.requiredStatusRequired.push( this.target.querySelectorAll('[name="'+ name +'"]') );
				length++;
			}

			/* ---------- index ---------- */
			this.requiredElements[i].dataset.n = length;
		}

		// -1からスタートしているので、1を足す
		this.requiredStatusTotalTarget.innerHTML = length + 1;
	};

	/* ---------- count ---------- */
	_requiredStatusCount = (targetElement) => {
		const control = this._searchControl( targetElement );
		const num     = targetElement.dataset.n;
		const name    = targetElement.getAttribute('name');
		const type    = targetElement.getAttribute('type');

		const inputs = this.target.querySelectorAll('[name="'+ name +'"]');

		let remaining = 0;


		/* ---------- checkbox,radioの場合、checkedで判定 ---------- */
		if( type == 'checkbox' || type == 'radio' ){
			for ( let i = 0; i < inputs.length; i++ ) {
				if( inputs[i].checked == true ){
					if( !control.classList.contains( this.options['errorClass'] ) ){
						this.requiredStatusStatus[num] = 1;
					} else{
						this.requiredStatusStatus[num] = 0;
					}
					break;
				} else{
					this.requiredStatusStatus[num] = 0;
				}
			}
		} else{
			/* ---------- それ以外はvalueで判定 ---------- */
			let value = targetElement.value;

			if( value !== '' ){
				if( !control.classList.contains( this.options['errorClass'] ) ){
					this.requiredStatusStatus[num] = 1;
				} else{
					this.requiredStatusStatus[num] = 0;
				}
			} else{
				this.requiredStatusStatus[num] = 0;
			}
		}

		/* ---------- count ---------- */
		for ( let i = 0; i < this.requiredStatusStatus.length; i++ ) {
			if( this.requiredStatusStatus[i] == 0 ){
				remaining++;
			}
		}

		/* ---------- 表示値（モード切替） ---------- */
		const totalItems = this.requiredStatusStatus.length;
		const completed  = totalItems - remaining;

		let displayNum;

		if ( this.options['requiredStatusMode'] === 'completed' ){
			displayNum = completed;
		} else {
			displayNum = remaining;
		}


		/* ---------- セット ---------- */
		this.requiredStatusCurrentTarget.innerHTML = displayNum;
		this.requiredStatusRemaining               = remaining;


		/* ---------- 必須が全て記入されたかのチェック ---------- */
		if( this.requiredStatusRemaining == 0 ){
			this.target.classList.add( this.options['doneClass'] );
			this.button.classList.remove( this.options['disabledClass'] );
		} else{
			this.target.classList.remove( this.options['doneClass'] );
			this.button.classList.add( this.options['disabledClass'] );
		}
	};

}

window.contactForm = contactForm;
